import { useEffect, useRef, useState } from "react";
import { createSse } from "../utils/sse";

export function useSse({ onMessage, onConnected, onError, enabled = true }) {
  const esRef = useRef(null);
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    if (!enabled) return;

    const es = createSse({});
    esRef.current = es;

    // 기본 메시지
    es.onmessage = (event) => {
      const data = JSON.parse(event.data);
      window.dispatchEvent(new CustomEvent("sse-message"));
      onMessage?.(data);
    };

    // custom events
    es.addEventListener("connected", (event) => {
      setConnected(true);
      onConnected?.(JSON.parse(event.data));
    });

    es.addEventListener("ping", () => {
      // keep alive
    });

    es.onerror = (err) => {
      setConnected(false);
      onError?.(err);
      console.error("❌ SSE error", err);
    };

    return () => {
      es.close();
      esRef.current = null;
    };
  }, [enabled]);

  return {
    connected,
    close: () => esRef.current?.close(),
  };
}
